import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

const plans = [
  {
    name: "Starter", price: "999", amount: 99900, leads: "500 Leads/month", color: "#00d4aa", popular: false,
    features: [
      { text:"500 qualified leads/month",        check:true  },
      { text:"Google Maps + JustDial + Sulekha", check:true  },
      { text:"IndiaMART leads",                  check:true  },
      { text:"AI lead scoring (Hot/Warm/Cold)",  check:true  },
      { text:"Auto email delivery every 30 min", check:true  },
      { text:"CRM pipeline tracking",            check:true  },
      { text:"CSV export",                       check:true  },
      { text:"Duplicate detection",              check:true  },
      { text:"AI chatbot",                       check:true  },
      { text:"API access",                       check:false },
      { text:"24/7 dedicated support",           check:false },
    ],
  },
  {
    name: "Pro", price: "1,999", amount: 199900, leads: "2000 Leads/month", color: "#ff6b35", popular: true,
    features: [
      { text:"2000 qualified leads/month",       check:true },
      { text:"All 6 platforms",                  check:true },
      { text:"Naukri.com job leads",             check:true },
      { text:"AI lead scoring (Hot/Warm/Cold)",  check:true },
      { text:"Auto email delivery every 30 min", check:true },
      { text:"CRM pipeline tracking",            check:true },
      { text:"CSV export",                       check:true },
      { text:"Duplicate detection",              check:true },
      { text:"AI chatbot",                       check:true },
      { text:"Custom niches & cities",           check:true },
      { text:"API access",                       check:false },
    ],
  },
  {
    name: "Enterprise", price: "3,999", amount: 399900, leads: "Unlimited Leads", color: "#a855f7", popular: false,
    features: [
      { text:"Unlimited qualified leads",        check:true },
      { text:"All 6 platforms",                  check:true },
      { text:"AI lead scoring (Hot/Warm/Cold)",  check:true },
      { text:"Auto email delivery every 30 min", check:true },
      { text:"CRM pipeline tracking",            check:true },
      { text:"CSV export",                       check:true },
      { text:"Duplicate detection",              check:true },
      { text:"AI chatbot",                       check:true },
      { text:"Custom niches & cities",           check:true },
      { text:"Full API access",                  check:true },
      { text:"24/7 dedicated support",           check:true },
    ],
  },
];

export default function Payment() {
  const [loading, setLoading] = useState("");
  const [error, setError]     = useState("");
  const navigate = useNavigate();
  const email = localStorage.getItem("email") || "";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  
  const payAnnual = async (plan) => {
    setError(""); setLoading(plan.name);
    try {
      const res = await API.post("/create-annual-order", { amount: plan.amount });
      const order = res.data;
      const options = {
        key: "rzp_live_Samp1v4YMwWQPV",
        amount: order.amount,
        currency: "INR",
        name: "LeadBot Pro",
        description: plan.name,
        order_id: order.id,
        prefill: { email },
        theme: { color: "#a855f7" },
        handler: async (response) => {
          try { await API.post("/verify-annual-payment", { ...response, amount: plan.amount }); } catch {}
          alert("✅ Annual plan activated! You saved " + plan.saving);
          navigate("/dashboard");
        },
        modal: { ondismiss: () => setLoading("") },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (e) {
      setError(e?.response?.data?.detail || "Payment failed");
    }
    setLoading("");
  };

  return () => { if (document.body.contains(script)) document.body.removeChild(script); };
  }, []);

  const pay = async (plan) => {
    setError(""); setLoading(plan.name);
    try {
      const res = await API.post("/create-order", { amount: plan.amount });
      const order = res.data;
      if (!order.id) throw new Error("Order creation failed");
      const rzpKey = process.env.REACT_APP_RAZORPAY_KEY || "";
      if (!rzpKey) { setError("Razorpay key not configured. Add REACT_APP_RAZORPAY_KEY to Vercel environment variables."); setLoading(""); return; }
      if (!window.Razorpay) { setError("Payment gateway not loaded. Please refresh."); setLoading(""); return; }
      const options = {
        key: rzpKey, amount: order.amount, currency: "INR",
        name: "LeadBot Pro", description: plan.name + " Plan — Monthly",
        order_id: order.id, prefill: { email }, theme: { color: plan.color },
        handler: async (response) => {
          try { await API.post("/verify-payment", { ...response, email, amount: plan.amount }); } catch {}
          alert("Payment successful! Your " + plan.name + " plan is now active.");
          navigate("/dashboard");
        },
        modal: { ondismiss: () => setLoading("") }
      };
      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", (r) => { setError("Payment failed: " + r.error.description); setLoading(""); });
      rzp.open();
    } catch (e) {
      setError(e?.response?.data?.detail || e.message || "Payment failed.");
      setLoading("");
    }
  };


  const payAnnual = async (plan) => {
    setError(""); setLoading(plan.name);
    try {
      const res = await API.post("/create-annual-order", { amount: plan.amount });
      const order = res.data;
      const options = {
        key: "rzp_live_Samp1v4YMwWQPV",
        amount: order.amount,
        currency: "INR",
        name: "LeadBot Pro",
        description: plan.name,
        order_id: order.id,
        prefill: { email },
        theme: { color: "#a855f7" },
        handler: async (response) => {
          try { await API.post("/verify-annual-payment", { ...response, amount: plan.amount }); } catch {}
          alert("✅ Annual plan activated! You saved " + plan.saving);
          navigate("/dashboard");
        },
        modal: { ondismiss: () => setLoading("") },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (e) {
      setError(e?.response?.data?.detail || "Payment failed");
    }
    setLoading("");
  };

  return (
    <div style={{ minHeight:"100vh", background:"#050510", color:"#fff", fontFamily:"'DM Sans',sans-serif", padding:"40px 20px" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Syne:wght@700;900&display=swap" rel="stylesheet"/>
      <style>{`.pcard{transition:transform 0.3s}.pcard:hover{transform:translateY(-8px)}`}</style>
      <div style={{ maxWidth:1100, margin:"0 auto" }}>
        <div style={{ textAlign:"center", marginBottom:48 }}>
          <div onClick={() => navigate("/")} style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:900, color:"#00d4aa", marginBottom:12, cursor:"pointer" }}>⚡ LeadBot Pro</div>
          <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:40, fontWeight:900, marginBottom:12 }}>Choose Your <span style={{ color:"#00d4aa" }}>Plan</span></h1>
          <p style={{ color:"#9ca3af", fontSize:17, marginBottom:12 }}>All plans include auto lead generation + Customer Finder for B2C businesses</p>
        <div style={{ display:"flex", gap:10, justifyContent:"center", flexWrap:"wrap", marginBottom:16 }}>
          <div style={{ display:"inline-flex", gap:8, alignItems:"center", background:"#00d4aa18", border:"1px solid #00d4aa44", borderRadius:20, padding:"6px 16px", fontSize:13, color:"#00d4aa", fontWeight:700 }}>🎁 CRM Pipeline — FREE for all accounts</div>
          <div style={{ display:"inline-flex", gap:8, alignItems:"center", background:"#a855f718", border:"1px solid #a855f744", borderRadius:20, padding:"6px 16px", fontSize:13, color:"#a855f7", fontWeight:700 }}>🎯 Customer Finder — included in all paid plans</div>
          <div style={{ display:"inline-flex", gap:8, alignItems:"center", background:"#ff6b3518", border:"1px solid #ff6b3544", borderRadius:20, padding:"6px 16px", fontSize:13, color:"#ff6b35", fontWeight:700 }}>⚡ Auto leads every 30 min — all paid plans</div>
        </div>
          <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
            {["✅ Cancel anytime","✅ No hidden fees","✅ Instant activation","✅ Real verified leads"].map((t,i) => (
              <span key={i} style={{ background:"#00d4aa18", border:"1px solid #00d4aa33", borderRadius:20, padding:"5px 14px", fontSize:13, color:"#00d4aa", fontWeight:600 }}>{t}</span>
            ))}
          </div>
        </div>

        {error && <div style={{ background:"#f8717122", border:"1px solid #f87171", borderRadius:12, padding:"12px 20px", marginBottom:24, color:"#f87171", textAlign:"center", fontSize:14 }}>⚠️ {error}</div>}

        <div style={{ display:"flex", gap:20, justifyContent:"center", flexWrap:"wrap", alignItems:"flex-start" }}>
          {plans.map((plan, i) => (
            <div key={i} className="pcard" style={{ background:"linear-gradient(135deg,#0d0d1f,#111128)", border:plan.popular?"2px solid "+plan.color:"1px solid #ffffff0d", borderRadius:24, padding:32, width:310, position:"relative" }}>
              {plan.popular && <div style={{ position:"absolute", top:-14, left:"50%", transform:"translateX(-50%)", background:plan.color, color:"#050510", borderRadius:20, padding:"4px 18px", fontSize:12, fontWeight:700, whiteSpace:"nowrap" }}>MOST POPULAR</div>}
              <div style={{ color:plan.color, fontSize:12, fontWeight:700, marginBottom:6, textTransform:"uppercase", letterSpacing:1 }}>{plan.name}</div>
              <div style={{ fontFamily:"'Syne',sans-serif", fontSize:48, fontWeight:900, marginBottom:2 }}>₹{plan.price}</div>
              <div style={{ color:"#9ca3af", fontSize:13, marginBottom:6 }}>/month</div>
              <div style={{ color:plan.color, fontSize:15, fontWeight:700, marginBottom:4 }}>{plan.leads}</div>
              <div style={{ color:"#6b7280", fontSize:12, marginBottom:20 }}>{plan.searches}</div>
              <div style={{ borderTop:"1px solid #ffffff0d", paddingTop:20, marginBottom:24 }}>
                {plan.features.map((f,j) => (
                  <div key={j} style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10, fontSize:13, color:f.check?"#d1d5db":"#4b5563" }}>
                    <span style={{ color:f.check?plan.color:"#374151", flexShrink:0 }}>{f.check?"✓":"✗"}</span>{f.text}
                  </div>
                ))}
              </div>
              <button onClick={() => pay(plan)} disabled={!!loading} style={{ width:"100%", background:plan.popular?plan.color:"transparent", color:plan.popular?"#050510":plan.color, border:"1px solid "+plan.color, borderRadius:12, padding:14, fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:15, cursor:loading?"not-allowed":"pointer", opacity:loading&&loading!==plan.name?0.5:1 }}>
                {loading===plan.name ? "Processing..." : `Get ${plan.name} — ₹${plan.price}/mo →`}
              </button>
            </div>
          ))}
        </div>

        <div style={{ maxWidth:700, margin:"48px auto 0", background:"#0d0d1f", border:"1px solid #ffffff0d", borderRadius:20, padding:28 }}>
          <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:18, marginBottom:20, textAlign:"center" }}>What's included in <span style={{ color:"#00d4aa" }}>every</span> paid plan</h3>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
            {["✅ Real leads from 6 platforms",
              "✅ Customer Finder for B2C businesses","✅ AI scoring Hot/Warm/Cold","✅ Auto email every 30 minutes","✅ CRM pipeline tracking","✅ CSV export","✅ CRM pipeline — free for everyone",
              "✅ Duplicate phone detection","✅ AI chatbot assistant","✅ 🎯 Customer Finder included"
].map((t,i) => (
              <div key={i} style={{ fontSize:13, color:"#9ca3af" }}>{t}</div>
            ))}
          </div>
        </div>

        <div style={{ textAlign:"center", marginTop:32, color:"#6b7280", fontSize:13 }}>
          Questions? <a href="tel:+919588331323" style={{ color:"#00d4aa", textDecoration:"none" }}>+91 9588331323</a> · <a href="mailto:parmjeetgadwal@gmail.com" style={{ color:"#00d4aa", textDecoration:"none" }}>parmjeetgadwal@gmail.com</a>
        </div>
        <p onClick={() => navigate("/dashboard")} style={{ textAlign:"center", marginTop:16, color:"#4b5563", fontSize:13, cursor:"pointer" }}>← Back to Dashboard</p>
      </div>
    </div>
  );
}
